(() => {
  'use strict';
  const isPending = panel => !!panel.querySelector('[data-pending]');
  const closeWidth = (panel, restoreFocus = false) => {
    if (isPending(panel)) return;
    panel.open = false;
    if (restoreFocus) {
      panel.dataset.restoringFocus = 'true';
      panel.querySelector('summary').focus();
      delete panel.dataset.restoringFocus;
    }
  };
  document.addEventListener('pointerover', event => {
    const panel = event.target.closest('[data-mz-card-width]');
    if (panel && event.pointerType === 'mouse' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) panel.open = true;
  });
  document.addEventListener('pointerout', event => {
    const panel = event.target.closest('[data-mz-card-width]');
    if (panel && !panel.contains(event.relatedTarget) && !panel.contains(document.activeElement)) closeWidth(panel);
  });
  document.addEventListener('focusin', event => {
    const summary = event.target.closest('[data-mz-card-width] > summary');
    if (!summary || !summary.matches(':focus-visible') || summary.parentElement.dataset.restoringFocus) return;
    summary.parentElement.open = true;
    summary.parentElement.querySelector('[data-mz-width-choice]:not(:disabled)')?.focus();
  });
  document.addEventListener('focusout', event => {
    const panel = event.target.closest('[data-mz-card-width]');
    if (panel && !panel.contains(event.relatedTarget)) closeWidth(panel);
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-mz-card-width][open]').forEach(panel => {
      if (!panel.contains(event.target)) closeWidth(panel);
    });
  });
  document.addEventListener('toggle', event => {
    const panel = event.target;
    if (!panel.matches?.('[data-mz-card-width]') || !panel.open) return;
    document.querySelectorAll('[data-mz-card-width][open]').forEach(other => {
      if (other !== panel && !other.querySelector('[data-mz-card-purchase][data-pending]')) other.open = false;
    });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const panel = event.target.closest('[data-mz-card-width][open]');
    if (!panel || isPending(panel)) return;
    event.preventDefault();
    closeWidth(panel, true);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-mz-card-purchase]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    if (form.dataset.pending) return;
    const submitter = event.submitter;
    const variantId = submitter?.matches('[data-mz-width-choice]') ? submitter.value : form.querySelector('[name="id"]')?.value;
    if (!variantId || submitter?.disabled) return;
    const control = form.closest('.MonzoroCardPurchase') || form;
    const panel = control.matches('[data-mz-card-width]') ? control : null;
    const status = form.querySelector('[role="status"]');
    const states = [...form.querySelectorAll('button')].map(button => ({ button, disabled: button.disabled }));
    form.dataset.pending = 'true';
    states.forEach(({ button }) => { button.disabled = true; });
    if (submitter) submitter.setAttribute('aria-busy', 'true');
    status.textContent = '';
    control.classList.add('is-feedback');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    try {
      const response = await fetch(form.action + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || status.dataset.errorMessage);
      if (panel) panel.open = false;
      if (window.MonzoroPocketOffer || (window.theme && window.theme.pageType !== 'cart' && document.getElementById('sidebar-cart'))) {
        form.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: result, quantity: 1 } }));
      } else {
        window.location.assign(window.routes ? window.routes.cartUrl : '/cart');
      }
    } catch (error) {
      status.textContent = error.message || status.dataset.errorMessage;
    } finally {
      states.forEach(({ button, disabled }) => { button.disabled = disabled; });
      if (submitter) submitter.removeAttribute('aria-busy');
      delete form.dataset.pending;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (!status.textContent) control.classList.remove('is-feedback');
    }
  });
})();


